
import { getCurrencies } from "../api";
import { SET_CURRENCIES } from "./actionTypes";

export const getCurrenciesData = () => async (dispatch) => {
  try {
    const response = await getCurrencies();
    await dispatch({
      type: SET_CURRENCIES,
      payload: response.result,
    });
  } catch (err) {
    dispatch({
      type: SET_CURRENCIES,
      payload: null,
    });
  }
};
